import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.go-fiesta.com';

export const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
});

// ============ Token helpers ============
export const getAccess = () => localStorage.getItem('gf_access');
export const getRefresh = () => localStorage.getItem('gf_refresh');
export const setTokens = ({ access, refresh }) => {
  if (access) localStorage.setItem('gf_access', access);
  if (refresh) localStorage.setItem('gf_refresh', refresh);
};
export const clearTokens = () => {
  localStorage.removeItem('gf_access');
  localStorage.removeItem('gf_refresh');
  localStorage.removeItem('gf_user');
};

// ============ Interceptor request ============
api.interceptors.request.use((config) => {
  const token = getAccess();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ============ Interceptor response (refresh) ============
let refreshing = null;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    const status = error.response?.status;

    // Solo intentar refresh si es 401 y no es un endpoint de auth
    if (
      status === 401 &&
      !original._retry &&
      !original.url?.includes('/auth/login') &&
      !original.url?.includes('/auth/refresh') &&
      !original.url?.includes('/auth/register')
    ) {
      original._retry = true;
      const refreshToken = getRefresh();

      if (!refreshToken) {
        clearTokens();
        if (!window.location.pathname.startsWith('/login')) {
          window.location.href = '/login';
        }
        return Promise.reject(error);
      }

      try {
        // Evitar múltiples refreshes en paralelo
        if (!refreshing) {
          refreshing = axios
            .post(`${API_URL}/api/auth/refresh`, { refreshToken })
            .then((res) => {
              setTokens({ access: res.data.access, refresh: res.data.refresh });
              if (res.data.user) {
                localStorage.setItem('gf_user', JSON.stringify(res.data.user));
              }
              return res.data;
            })
            .finally(() => {
              setTimeout(() => { refreshing = null; }, 0);
            });
        }

        const data = await refreshing;
        original.headers.Authorization = `Bearer ${data.access}`;
        return api(original);
      } catch (refreshErr) {
        clearTokens();
        window.location.href = '/login';
        return Promise.reject(refreshErr);
      }
    }

    return Promise.reject(error);
  }
);

// Extrae el mensaje de error uniforme de la API
export const getErrorMessage = (error) =>
  error?.response?.data?.message ||
  error?.message ||
  'Error inesperado';